export enum FiItemsListOptionType {
    Common = 0,
    Icon = 1,
    Checkbox = 2,
}
